import React, { useEffect, useRef } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Home from "./pages/Home";
import ThankYou from "./pages/ThankYou";
import { trackPageView } from "./utils/analytics";
import { initCalltouch } from "./utils/calltouch";
import "./App.css";

/**
 * Лендинг — SPA, поэтому переход на /thank-you не перезагружает страницу
 * и Метрика сама его не увидит. Досылаем просмотр вручную на каждой смене
 * маршрута, кроме самой первой (её уже отправил счётчик из index.html).
 */
function RouteTracker() {
  const location = useLocation();
  const firstRender = useRef(true);

  useEffect(() => {
    if (firstRender.current) {
      firstRender.current = false;
      return;
    }
    trackPageView(location.pathname + location.search);
  }, [location.pathname, location.search]);

  return null;
}

function App() {
  // Запускаем Calltouch после первой отрисовки: к этому моменту номера
  // уже в DOM и подмене есть что заменять
  useEffect(() => {
    initCalltouch();
  }, []);

  return (
    <BrowserRouter>
      <RouteTracker />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/thank-you" element={<ThankYou />} />
        <Route path="*" element={<Home />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
